import React from "react";
import { useTranslation } from "react-i18next";

import './dataVisualization.scss'


function DataVisualization() {
    const { t } = useTranslation()

    return (
        <div className="container-data-visualization">
            <div className="texts-data-visualization">
                <div>
                    <h1>{t("rapid_dashboard.data_visualization.title")}</h1>
                    <p>{t("rapid_dashboard.data_visualization.section_text_1")}</p>
                    <p>{t("rapid_dashboard.data_visualization.section_text_2")}</p>
                </div>
                <br />
                <div>
                    <h1>{t("rapid_dashboard.impressive_dashboards.title")}</h1>
                    <p>{t("rapid_dashboard.impressive_dashboards.section_text_1")}</p>
                    <p>{t("rapid_dashboard.impressive_dashboards.section_text_2")}</p>
                    <p>{t("rapid_dashboard.impressive_dashboards.section_text_3")}</p>
                </div>
            </div>
        </div>
    )
}

export default DataVisualization